class RecentlyViewedProducts extends HTMLElement {
	constructor() {
		super();
		this.el = this;
		this.section = this.closest('.shopify-section');
		this.sectionId = this.getAttribute('section-id');
		this.isLoaded = false;
		this.searchQueryString = new WeakSet();
		this.loadProducts = new WeakSet();
		this.slider = null;
	}

	getSearchQueryString() {
		const items = new Set(
			JSON.parse(localStorage.getItem('theme:recently-viewed-products') || '[]')
		);
		if (this.hasAttribute('exclude-id')) {
			items.delete(parseInt(this.getAttribute('exclude-id')));
		}
		return Array.from(items.values(), (item) => `id:${item}`)
			.slice(0, parseInt(this.getAttribute('products-count')))
			.join(' OR ');
	}

	loadProductsFn() {
		if (this.isLoaded) {
			return;
		}
		this.isLoaded = true;

		const url = `${
			Shopify.routes.root
		}search?type=product&q=${this.getSearchQueryString()}&section_id=${
			this.sectionId
		}`;

		fetch(url, { priority: 'low' })
			.then((response) => response.text())
			.then((responseText) => {
				const tempDiv = new DOMParser().parseFromString(
					responseText,
					'text/html'
				);
				const recentlyViewedProductsElement = tempDiv.querySelector(
					'recently-viewed-products'
				);
				if (recentlyViewedProductsElement.childElementCount > 0) {
					this.replaceChildren(
						...document.importNode(recentlyViewedProductsElement, true)
							.childNodes
					);
					this.initSlider();
				} else {
					this.section.remove();
				}
			});
	}

	connectedCallback() {
		this.loadProductsFn();
	}

	initSlider() {
		this.splide = this.querySelector('.splide');
		const slider = new Splide(this.splide, {
			perPage: 4,
      perMove: 1,
      pagination: false,
      gap: '1rem',
      classes: {
        arrows: 'hidden lg:block',
      },
      breakpoints: {
        640: {
          perPage: 1,
          gap: '.75rem',
        },
				768: {
          perPage: 2
        },
      }
		});

		const bar = slider.root.querySelector('.splide__progress__bar');
		// Updates the bar width whenever the carousel moves:
		slider.on('mounted move', function () {
			var end = slider.Components.Controller.getEnd() + 1;
			var rate = Math.min((slider.index + 1) / end, 1);
			bar.style.width = String(100 * rate) + '%';
		});

		slider.mount();
	}
}

// Initialize the component
if (!window.customElements.get('recently-viewed-products')) {
	window.customElements.define(
		'recently-viewed-products',
		RecentlyViewedProducts
	);
}
